import { render, staticRenderFns } from "./Sopa.vue?vue&type=template&id=6a6c288c&scoped=true&"
import script from "./Sopa.vue?vue&type=script&lang=js&"
export * from "./Sopa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6c288c",
  null
  
)

export default component.exports